export class PaginationData {
  pageNumber: number;
  pageLabel: string;
}
